// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 65648, offsets 249563:266248. Structure and names inferred from code, not screenshots.

import * as LocalizedPathsModule from "./localizedPaths.js";
import o from "../content/extracted/65648-o.json";
let a = "/docs",
  r = Array.isArray(o) && o.length > 0;
!r &&
  "u" > typeof console &&
  console.warn(
    "[docs] pages/documents.json 为空，使用最小回退。请检查 CI 是否错误执行 pre-build，或 doc-settings.json 是否缺失节点。",
  );
let l = r
  ? o
  : [
      {
        key: "欢迎使用",
        titleZh: "欢迎使用",
        titleEn: "Welcome",
        href: "/welcome",
      },
    ];
function s() {
  return l.filter((e) => "key" in e && !("spacer" in e));
}
function c(e, t) {
  return (function e(t, i) {
    if ("spacer" in t) return null;
    let n = t.href ? `${i}${t.href}` : i;
    if (t.items && t.items.length > 0) {
      for (let i of t.items) {
        let t = e(i, n);
        if (t) return t;
      }
      return null;
    }
    return t.href && !t.noLink ? n : null;
  })(e, t);
}
function d(e) {
  let t = `/${e.replace(/^\/+/u, "").replace(/\/+$/u, "")}`,
    i = (function e(i, n) {
      for (let o of i) {
        if ("spacer" in o) continue;
        let i = o.href ? `${n}${o.href}` : n;
        if (i === t)
          return {
            node: o,
            fullPath: n,
          };
        if (o.items) {
          let t = e(o.items, i);
          if (t) return t;
        }
      }
      return null;
    })(l, "");
  if (!i) return null;
  let { node: node, fullPath: fullPath } = i;
  return node.items && node.items.length > 0 ? c(node, fullPath) : null;
}
function u(e, t = "zh") {
  let i = (0, LocalizedPathsModule.$C)(e).replace(/\/$/, "") || e,
    o = (0, LocalizedPathsModule.Qe)(e, t);
  for (let e of s())
    if (e.items) {
      let t = p(e.items, "", o);
      if (
        (e.href && t.push(`${o}${e.href}`),
        t.some((e) => i === e || i.startsWith(`${e}/`)))
      )
        return e;
    } else if (e.href) {
      let t = `${o}${e.href}`;
      if (i === t || i.startsWith(`${t}/`)) return e;
    }
  return null;
}
function p(e, t = "", i = "/docs") {
  let n = [];
  for (let o of e) {
    if ("spacer" in o || !("key" in o)) continue;
    let e = o.href,
      r = t;
    if (o.agreementFullPath) {
      let e = String(o.agreementFullPath).replace(/^\/+/u, "");
      ((r = e ? `${a}/${e}` : a), n.push(r));
    } else e && ((r = t ? `${t}${e}` : `${i}${e}`), n.push(r));
    o.items?.length && n.push(...p(o.items, r, i));
  }
  return n;
}
function m(e, t = "zh") {
  let i = (0, LocalizedPathsModule.$C)(e).replace(/\/$/, "") || e,
    o = [...new Set(p(l, "", (0, LocalizedPathsModule.Qe)(e, t)))].filter(
      (e) => i === e,
    );
  if (0 === o.length) return null;
  let a = o[0];
  for (let e = 1; e < o.length; e++) {
    let t = o[e];
    t.length > a.length && (a = t);
  }
  return a;
}
l.flatMap((e) =>
  (function e(t) {
    let i = [];
    if (
      ("key" in t &&
        t.href &&
        !t.noLink &&
        i.push({
          key: t.key,
          href: t.href,
        }),
      "key" in t && t.items)
    )
      for (let n of t.items) i.push(...e(n));
    return i;
  })(e),
);
export { l as jj, u as f2, m as de, d as UI, c as W1, s as a8 };
